import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'tableFilter'
})
export class TableFilterPipe implements PipeTransform {

  transform(value: any, keys: string, filter: any) {
    return (value || [])
      .filter(item =>
        keys.split(',')
          .some(key => item.hasOwnProperty(key) && item[key] === filter));
  }

}
